import { getInstance } from './auth0-plugin'

const maintenance = JSON.parse(process.env.VUE_APP_MAINTENANCE_STATUS)
const vendorBlackoutStart = new Date(process.env.VUE_APP_VENDOR_BLACKOUT_START)
const vendorBlackoutEnd = new Date(process.env.VUE_APP_VENDOR_BLACKOUT_END)

export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const guardAction = () => {
    if (authService.isAuthenticated) {
      const { tenant, userRoles } = authService
      if (authService.tenantTitle) {
        document.title = `${authService.tenantTitle} | ${to.meta?.title}`
      }
      if (tenant === 'alliance-retail-group') {
        const today = new Date()
        const vendorBlackoutActive = (today >= vendorBlackoutStart) && (today < vendorBlackoutEnd)
        const isBlockedVendor = userRoles.includes('arg-vendor') && !userRoles.includes('vendor-blackout-exempt')
        if (vendorBlackoutActive && isBlockedVendor) {
          if (to.path !== '/access-disabled') return next('/access-disabled')
          else return next()
        } else {
          if (to.path === '/access-disabled') return next('/')
        }
      } else {
        if (to.path === '/access-disabled') return next('/')
      }
      if (maintenance) {
        if (to.path !== '/') return next('/')
        else return next()
      }
      return next()
    }
    const options = { appState: { targetUrl: to.fullPath } }
    authService.loginWithRedirect({ ...options })
  }

  // If the Auth0Plugin has loaded already, check the authentication state
  if (!authService.isLoading) {
    return guardAction()
  }

  authService.$watch('isLoading', (isLoading) => {
    if (isLoading === false) {
      return guardAction()
    }
  })
}
